import { render, staticRenderFns } from "./CollaborationOffer.vue?vue&type=template&id=17d9805f&scoped=true&"
import script from "./CollaborationOffer.vue?vue&type=script&lang=js&"
export * from "./CollaborationOffer.vue?vue&type=script&lang=js&"
import style0 from "./CollaborationOffer.vue?vue&type=style&index=0&id=17d9805f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d9805f",
  null
  
)

export default component.exports